import { Autocomplete, Box, Button, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Modal, Paper, Radio, RadioGroup, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react';
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { CommonGridToolBarWithExtraFilter, CommonPatientDetails, DeletePopup, OpenWebCamPopUP } from '../../Components/Common Components/CommonComponents';
import { getCachevalue, localGetItem } from '../../Utility/Services/CacheProviderService';
import { DataGrid } from '@mui/x-data-grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { DateTime } from 'luxon';
import { dataURItoFile } from '../../Components/CommonFunctions/CommonFunctions';

const MrdDocumentsAdd = (props) => {
  let patientData = getCachevalue("MRDpatientDetails") ? getCachevalue("MRDpatientDetails") : null
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [CategoryList, setCategoryList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [patientDetails, setpatientDetails] = useState(patientData ? JSON.parse(patientData) : null);
  const [selectedCategory, setselectedCategory] = useState(null);
  const [selectedLocation, setselectedLocation] = useState(null);
  const [docuName, setDocuName] = useState("");
  const [medicoLegel, setmedicoLegel] = useState("no");
  const [visitDate, setVisitDate] = useState(null);
  const [DocumentsList, setDocumentsList] = useState([]);
  const [documentType, setDocumentType] = useState(null);
  const [isloader, setisloader] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [searchDoc, setSearchDoc] = useState(null);

  const [Image, setImage] = useState(
    {
      open: false,
      imageuploadList: [],
      imageViewerPopup: false,
      viewData: [],
      viewImage: null,
      selectedImage: null,
      imgCapClked: false,
      CapturedImg: null,
      currentIndex: 0,
    }
  );

  const uploadImage = useRef(null);

  const DocTypeList = [
    { name: 'Out Patient', value: 'op' },
    { name: 'In Patient', value: 'ip' }
  ]

  useEffect(() => {
    getCategoryMaster()
    getDocumentsList()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }

  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const getCategoryMaster = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_CATEGORY_GET_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            let FilteredData = Data.filter(item => item.is_active === true)
            setCategoryList(FilteredData || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getLocationMaster = (rackID) => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_RACK_GET_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            let FilteredData = Data.filter(item => item.is_active === true)
            let selectedRack = FilteredData?.length > 0 ? FilteredData?.find((item) => item?.id == rackID) : null;
            setLocationList(FilteredData)
            setselectedLocation(selectedRack)
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getDocumentsList = (DocType) => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_DOCUMENTS_ADD + `?patient_id=${patientDetails?.patient_id || null}&document_type=${DocType?.value || ''}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let selectedRack = response?.data?.documents.length > 0 ? response?.data?.documents[0]?.rack_id : null;
            setDocumentsList(response?.data?.documents || [])
            getLocationMaster(selectedRack)
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const PopupClose = () => {
    setisDelete(false);
    setdeletedID(null)
  }

  const deletePatientDocument = () => {
    try {
      RestAPIService.delete(Serviceurls.MRD_DOCUMENTS_ADD + `?id=${deletedID || null}`)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            getDocumentsList()
            setdeletedID(null);
            setisDelete(false)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getS3Key = async (doc_key, id) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

      if (response.data.status === "success") {
        const Data = response.data;
        return {
          data_url: Data.data
        };
      }
    } catch (e) {
      setisloader(false)
      errorMessage("Error fetching S3 URL")
    }
  }

  const renderImage = async (imageData, pdfData) => {
    let tempArr = [];

    if (imageData.length > 0) {
      for (let i = 0; i < imageData.length; i++) {
        let image = imageData[i];
        if (image !== null) {
          let doc_key = image;
          let getData = await getS3Key(doc_key); // make sure this is a top-level async function
          getData["type"] = image.split('.').pop() === "pdf" ? "pdf" : "image";
          tempArr.push(getData);
        }
      }
    }

    setImage(prev => {
      const updated = {
        ...prev,
        viewData: tempArr,
        viewImage: tempArr[0]
      };

      // Do window.open *after* state is set
      if (pdfData) {
        setTimeout(() => {
          if (updated.viewImage?.data_url) {
            window.open(updated.viewImage.data_url);
          }
        }, 0);
      }

      return updated;
    });
  };

  const onImageHandler = async (e) => {
    const imageList = [];
    let imageFiles = [...e.target.files];

    let clearedArr = imageFiles?.filter((image, i) => {
      let file = image?.name;
      return String(file).toLowerCase() !== String(imageFiles[i + 1]?.name).toLowerCase();
    });

    for (let i = 0; i < clearedArr.length; i++) {
      imageList.push(clearedArr[i]);
    }

    const newList = await Promise.all(imageList);

    setImage((prev) => ({
      ...prev,
      imageuploadList: [...prev.imageuploadList, ...newList],
    }));

    e.target.value = '';
  };

  const onImageRemove = (index) => {
    setImage((prev) => {
      const updatedList = [...prev.imageuploadList];
      updatedList.splice(index, 1);
      return {
        ...prev,
        imageuploadList: updatedList,
      };
    });
  };

  const prevImage = (index) => {
    let currentIndex = parseInt(index) || 0;

    if (currentIndex >= 1) {
      setImage((prev) => ({
        ...prev,
        currentIndex: currentIndex - 1,
        viewImage: prev.viewData[currentIndex - 1],
      }));
    }
  };

  const nextImage = (index) => {
    let currentIndex = parseInt(index) || 0;

    if (currentIndex + 1 < Image.viewData.length) {
      setImage((prev) => ({
        ...prev,
        currentIndex: currentIndex + 1,
        viewImage: prev.viewData[currentIndex + 1],
      }));
    }
  };

  const renderImageViewerPopup = () => {
    try {
      if (Image.viewData?.length > 0) {
        return (
          <Box component={'div'}>
            <Modal open={Image.imageViewerPopup}>
              <Box className='eMed_Doc_Img_Pop_Up'>
                <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'1vw'} alignItems={'center'} justifyContent={'space-between'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                    MRD Documents
                  </Typography>
                  <Button
                    onClick={() =>
                      setImage((prev) => ({
                        ...prev,
                        imageViewerPopup: false,
                      }))
                    }
                  >
                    <Box
                      component={'img'}
                      src={ImagePaths.LabCloseButton.default}
                      height={'1vw'}
                      width={'1vw'}
                      mr={'1vw'}
                    />
                  </Button>
                </Box>

                <Box height={'30vw'} display={'flex'} justifyContent={'center'}>
                  {Image.viewData?.length > 1 && (
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                      <Button
                        size="small"
                        className="Common_Btn_Min_Width"
                        sx={{ height: '3vw' }}
                        onClick={() => prevImage(Image.currentIndex)}
                      >
                        <KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                      </Button>
                    </Box>
                  )}

                  {Image.viewImage?.type === 'pdf' ? (
                    <Box>
                      <img
                        style={{ width: '12vw', height: '12vw' }}
                        src={ImagePaths.DocumentPreview.default}
                        alt="slide"
                      />
                      <Button variant="contained" onClick={() => window.open(Image.viewImage?.data_url)}>
                        Download Document
                      </Button>
                    </Box>
                  ) : (
                    <Box component={'div'} height={'30vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                      <img
                        src={Image.viewImage?.data_url || ''}
                        alt="slide"
                        style={{ objectFit: 'contain', height: '15vw', width: '30vw' }}
                      />
                    </Box>
                  )}

                  {Image.viewData?.length > 1 && (
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                      <Button
                        size="small"
                        className="Common_Btn_Min_Width"
                        sx={{ height: '3vw' }}
                        onClick={() => nextImage(Image.currentIndex)}
                      >
                        <KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Modal>
          </Box>
        );
      }
      return null;
    } catch (error) {
      errorMessage(error?.message)
    }
  };

  const closeWebCamPop = () => {
    setImage((prev) => ({
      ...prev,
      imgCapClked: false,
      CapturedImg: null,
    }));
  };

  const addImgCapture = (data) => {
    if (data) {
      setImage((prev) => ({
        ...prev,
        imageuploadList: [
          ...prev.imageuploadList,
          dataURItoFile(data, `report_file_${Date.now()}.jpg`)
        ],
        imgCapClked: false,
      }));
    }
  };

  const UploadButton = (onClick, imgSrc, text) => {
    return (
      <Button sx={{ textTransform: "capitalize" }}
        disabled={Image.imageuploadList?.length === 6}
        onClick={onClick}
      >
        <Box
          component="div"
          borderRadius="10px"
          border="1px dotted gray"
          height="10vw"
          width="12vw"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box component="img" src={imgSrc} height="2vw" width="2vw" />
          <Typography fontSize="0.9vw" color={Colors.SecondaryText} fontWeight={600} mt="0.5vw">
            {Image.imageuploadList.length === 6 ? ("MaxUpload") : text}
          </Typography>
        </Box>
      </Button>
    );
  };


  const renderLeftSide = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <Autocomplete
              size='small'
              options={DocTypeList}
              sx={{ width: '18dvw', marginLeft: "0.5vw" }}
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
              value={searchDoc}
              onChange={(e, value) => {
                setSearchDoc(value)
                getDocumentsList(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Document Type"} />}
            />
            <CommonGridToolBarWithExtraFilter />
          </Box>
        )
      }
      DocumentsList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'document_name', headerName: 'Document Name', flex: 0.075,
          renderCell: (params) => (params.row.document_name ? params.row.document_name?.length > 35 ?
            <Tooltip placement="top" title={params.row.document_name}><Typography fontSize={'0.9vw'}>{params.row.document_name?.slice(0, 32) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.document_name || '-'}</Typography> : '-')
        },
        {
          field: 'uploaded_date', headerName: 'Uploaded Date', flex: 0.045, headerAlign: 'center', align: "center",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.uploaded_date ? (params?.row?.uploaded_date).split('-').reverse().join('-') : '-'}</Box>)
        },
        {
          field: 'visit_date', headerName: 'Visit Date', flex: 0.045, headerAlign: 'center', align: "center",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.visit_date ? (params?.row?.visit_date).split('-').reverse().join('-') : '-'}</Box>)
        },
        {
          field: 'document_type', headerName: 'Document Type', flex: 0.04,
          renderCell: (params) => (<Box component={'div'} fontWeight={600} textTransform={'uppercase'}>{params?.row?.document_type || '-'}</Box>)
        },
        {
          field: 'ver_no', headerName: 'Version No', flex: 0.03,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.ver_no || '0'}</Box>)
        },
        {
          field: 'is_medico_legal', headerName: 'Medico Legal', flex: 0.035,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.is_medico_legal ? 'Yes' : 'No'}</Box>)
        },
        {
          field: 'action', headerName: 'Action', flex: 0.035, headerAlign: 'center', align: 'center', disableExport: true,
          renderCell: (params) => (
            <Box component={'div'} style={{ display: "flex", flexDirection: "row", gap: '0.5vw' }}>
              <Box>
                {(
                  params?.row?.doc_key[0]?.includes('.pdf') ? (
                    <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                      <Button
                        className='Common_Btn_Min_Width'
                        onClick={() => {
                          if (params?.row?.doc_key?.length > 0) {
                            const imageFile = params?.row?.doc_key || [];
                            setImage(prev => ({
                              ...prev,
                              viewData: [],
                              viewImage: null,
                            }));
                            renderImage(imageFile, true);
                          } else {
                            errorMessage('No PDF to be view');
                          }
                        }}
                      >
                        <FileUploadIcon color='primary' />
                      </Button>
                    </Box>
                  ) : (
                    <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                      <Button
                        sx={{ textTransform: 'capitalize' }}
                        className='Common_Btn_Min_Width'
                        onClick={() => {
                          if (params?.row?.doc_key?.length > 0) {
                            const imageFile = params?.row?.doc_key || [];
                            setImage(prev => ({
                              ...prev,
                              imageViewerPopup: true,
                              viewOpen: true,
                              viewData: [],
                              viewImage: null
                            }));

                            renderImage(imageFile);
                          } else {
                            errorMessage('No image to be view');
                          }
                        }}
                      >
                        View
                      </Button>
                    </Box>
                  )
                )}
              </Box>
              {props?.Access?.editAccess ? <Tooltip title={"Delete Document"} placement="top" arrow>
                <Button
                  onClick={() => {
                    setisDelete(true)
                    setdeletedID(params?.row?.document_id)
                  }}
                  className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                  <img src={ImagePaths.LabDeleteButton.default} alt="barcode" style={{ width: '1.5vw', height: '1.5vw' }} />
                </Button>
              </Tooltip> : null}
            </Box>)
        },
      ];
      return (
        <Box sx={{ height: '69vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={DocumentsList}
            columns={columns}
            getRowId={(row) => row['sno']}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            hideFooter={true}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const postDocuments = () => {
    const UserData = JSON.parse(localGetItem('loggedInUserInfo'))

    if (!selectedCategory || !selectedLocation || !documentType || !visitDate) {
      errorMessage("Please enter mandatory fields");
      return;
    }
    if (visitDate == "Invalid DateTime") {
      errorMessage("Please select correct date");
      return;
    }
    if (!docuName?.trim()) {
      errorMessage("Enter a Document Name");
      return;
    }
    if (Image.imageuploadList.length <= 0) {
      errorMessage("Upload atleast one Image");
      return;
    }
    try {
      const dataForm = new FormData();
      dataForm.append('patient_id', patientDetails?.patient_id || null);
      dataForm.append('category_id', selectedCategory ? selectedCategory?.id : null);
      dataForm.append('rack_id', selectedLocation ? selectedLocation?.id : null);
      dataForm.append('document_name', docuName || '');
      dataForm.append('is_medico_legal', medicoLegel || 'no');
      dataForm.append('visit_date', visitDate ? DateTime.fromJSDate(new Date(visitDate)).toFormat('yyyy-MM-dd') : null)
      dataForm.append('document_type', documentType?.value || null);
      dataForm.append('clinic_id', UserData?.clinic_id || null);
      for (let i = 0; i < Image.imageuploadList.length; i++) {
        dataForm.append('doc_key', Image.imageuploadList[i])
      }

      setisloader(true)
      RestAPIService.create(dataForm, Serviceurls.MRD_DOCUMENTS_ADD)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            setisloader(false)
            setselectedCategory(null)
            setselectedLocation(null)
            setDocuName("")
            setVisitDate(null)
            setDocumentType(null)
            setmedicoLegel("no")
            getDocumentsList()
            setImage(prev => ({
              ...prev,
              open: false,
              imageuploadList: [],
              imageViewerPopup: false,
              viewData: [],
              viewImage: null,
              selectedImage: null,
              imgCapClked: false,
              CapturedImg: null,
            }))
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const renderRightSide = () => {
    return (
      <Box>
        <Typography className='eMed_refdoc_title'>{"Patient Documents"}</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', height: '20dvh', alignItems: 'center', justifyContent: 'space-around' }}>
          <Autocomplete
            clearIcon
            size='small'
            options={CategoryList}
            sx={{ width: '14dvw' }}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.category_name}
            value={selectedCategory}
            onChange={(e, value) => {
              setselectedCategory(value)
            }}
            renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Category *"} />}
          />
          <Autocomplete
            clearIcon
            size='small'
            sx={{ width: '14vw' }}
            options={LocationList}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.rack_name}
            value={selectedLocation}
            onChange={(e, value) => {
              setselectedLocation(value)
            }}
            renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Rack *"} />}
          />
          <TextField
            size='small'
            sx={{ width: "14dvw" }}
            value={docuName}
            label={"Document Name *"}
            autoComplete='off'
            inputProps={{ maxLength: 50 }}
            onChange={(e) => {
              setDocuName(e.target.value)
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={visitDate}
              inputFormat='DD-MM-YYYY'
              label={"Select Visit Date *"}
              maxDate={new Date()}
              onChange={
                (newDate) => {
                  if (newDate == null) {
                    setVisitDate(new Date());
                  } else {
                    setVisitDate(newDate);
                  }
                }}
              renderInput={(params) => <TextField style={{ width: '14dvw' }} size='small' {...params} />}
            />
          </LocalizationProvider>
          <Autocomplete
            clearIcon
            size='small'
            options={DocTypeList}
            sx={{ width: '29dvw' }}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
            value={documentType}
            onChange={(e, value) => {
              setDocumentType(value)
            }}
            renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Document Type *"} />}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ marginLeft: "0.5vw", marginRight: "1vw" }}>Medico Legal</Typography>
          <RadioGroup
            row
            value={medicoLegel}
            onChange={(e) => {
              setmedicoLegel(e.target.value)
            }}
          >
            <FormControlLabel value="yes" control={<Radio size='small' />} label={<Typography>Yes</Typography>} />
            <FormControlLabel value="no" control={<Radio size='small' />} label={<Typography>No</Typography>} />
          </RadioGroup>
        </Box>
        <Typography className='eMed_refdoc_title'>{"Upload Your Documents Here"}</Typography>
        <Box sx={{ marginTop: "0.75vw", height: "10vw", overflow: "scroll" }}>
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <Box component={'input'} type='file' sx={{ display: 'none' }}
              multiple
              accept="image/jpg, image/jpeg, image/png,application/pdf"
              ref={uploadImage}
              onChange={onImageHandler}
            />
            <Box>
              {UploadButton(() => {
                setImage((prev) => ({
                  ...prev,
                  imgCapClked: true,
                }));
              }, ImagePaths.CameraCapture.default, "Capture Image")}
              {UploadButton(() => uploadImage.current.click(), ImagePaths.LabUploadButton.default, "Browse Files")}
            </Box>
          </Box>
          {Image.imageuploadList?.length > 0 && (
            <Box
              component={'div'}
              display={'flex'}
              maxWidth={'29vw'}
              alignItems={'center'}
              justifyContent={'center'}
              overflow={'scroll'}
            >
              {Image.imageuploadList.map((image, index) => (
                <Box
                  component={'div'}
                  key={index}
                  mr={'0.5vw'}
                  height={'5vw'}
                  display={'flex'}
                  alignItems={'center'}
                >
                  <Tooltip title={typeof image === 'string' ? '' : image?.name} arrow placement="top">
                    <Box
                      component={'img'}
                      onClick={() => {
                        if (typeof image === 'string') {
                          const ext = image.split('.').pop()?.toLowerCase();
                          if (['jpg', 'jpeg', 'png'].includes(ext)) {
                            setImage((prev) => ({
                              ...prev,
                              isImgClicked: true,
                              popUpOpen: true,
                              selectedImage: image,
                            }));
                          } else {
                            window.open(image);
                          }
                        }
                      }}
                      src={
                        typeof image === 'string'
                          ? ['jpg', 'jpeg', 'png'].includes(image.split('.').pop()?.toLowerCase())
                            ? image
                            : ImagePaths.DocumentPreview.default
                          : image?.type === 'image/jpeg' || image?.type === 'image/png'
                            ? ImagePaths.ImagePreview.default
                            : ImagePaths.DocumentPreview.default
                      }
                      height={'4vw'}
                      width={'3.5vw'}
                    />
                  </Tooltip>
                  <Box>
                    <IconButton
                      sx={{ position: 'relative', bottom: '1.2vw', right: '1.4vw' }}
                      size="small"
                      onClick={() => {
                        setImage((prev) => ({
                          ...prev,
                          selectedImage: null,
                        }));
                        onImageRemove(index); // You must define `onImageRemove` in your functional component
                      }}
                    >
                      <CancelTwoToneIcon fontSize="small" color="error" />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0.5dvw' }}>
          <Button size='small' sx={{ textTransform: "capitalize" }} variant='outlined' onClick={() => {
            setselectedCategory(null);
            setselectedLocation(null);
            setDocuName('');
            setVisitDate(null);
            setmedicoLegel("no");
            setDocumentType(null)
            setImage(prev => ({
              ...prev,
              open: false,
              imageuploadList: [],
              imageViewerPopup: false,
              viewData: [],
              viewImage: null,
              selectedImage: null,
              imgCapClked: false,
              CapturedImg: null,
            }))
          }}>Clear</Button>
          <Button size='small' sx={{ textTransform: "capitalize", marginLeft: "1vw" }} disabled={!props?.Access?.editAccess} variant='contained' onClick={() => { postDocuments() }}>Add</Button>
        </Box>
      </Box>
    )
  }
  return (
    <Box component={"div"} className={'eMed_bill_container'}>
      <Box sx={{ height: '9.5dvh', padding: '0.5dvw' }}>
        <Box component={'div'} sx={{
          backgroundColor: 'white', borderRadius: '5px',
          boxShadow: '0px 0px 3px gray', width: '23vw', height: '3.5vw', padding: '0.2vw',
        }}>
          <CommonPatientDetails data={patientDetails} />
        </Box>
      </Box>
      <Grid container className={'eMed_bill_content'} >
        <Grid container className={'eMed_bill_content1'} spacing={1}>
          <Grid item xs={8}>
            <Paper sx={{ height: '70dvh' }}>
              {renderLeftSide()}
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper sx={{ height: '70dvh', padding: '0.5dvw' }}>
              {renderRightSide()}
            </Paper>
          </Grid>
        </Grid>
        {renderImageViewerPopup()}
      </Grid>
      {Image.imgCapClked && (
        <OpenWebCamPopUP
          capturedImg={Image.CapturedImg}
          closePopup={closeWebCamPop}
          addImgCapture={addImgCapture}
        />
      )}
      {isDelete ?
        <DeletePopup
          DeletTitle={`Are you sure you want to delete this document ?`}
          deleteAlertPopupClose={PopupClose.bind(this)}
          removeData={deletePatientDocument.bind(this)}
          ButtonText={'Yes'}
        />
        : null}
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  )
}

export default MrdDocumentsAdd